<template>
    <div id="wrapper" >
      <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.companies.found.admin.label.title')}}</h4>

                            </div>
                        </div>
                    </div>

                     <div class="row">
                       
                       <div class="col-lg-12">
                        <div class="card-box">
                            <h4 class="header-title mb-4">
                                <h4 class="page-title">
                                    {{$t('string.msg.history.admin.label.title')}}
                                </h4>
                            </h4>
                     
                            <div>
                                <b-tabs>

                                    <b-tab active :class="{ 'hidden': !hasType('PART_SUPPLIER') }">
                                    <template v-slot:title>
                                        <strong>{{$t('string.msg.product.parts.label.title')}}</strong>
                                    </template>
                                    <ListOrdersParts />
                                    </b-tab>

                                    <b-tab v-bind:class="{ 'hidden': !hasType('SERVICE_PROVIDER') }">
                                    <template v-slot:title>
                                         <strong>{{$t('string.msg.dashboard.services.tab')}}</strong>
                                    </template>
                                    <ListOrdersServices />
                                    </b-tab>
                                    
                                    <b-tab v-bind:class="{ 'hidden': !hasType('CERTIFIER') }">
                                    <template v-slot:title>
                                        <strong>{{$t('string.msg.dashboard.certifie.tab')}}</strong>
                                    </template>
                                    <ListOrdersCertifie />
                                    </b-tab>

                                </b-tabs>
                            </div>
                            
                        </div>
                        <!-- end card-box-->
                      </div>
                      <!-- end col -->
                     </div>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <ModalTermParts  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTermCertifies  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTermServices  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTerm v-on:confirmation-return="acceptedTermGeneral"/>
    </div>
</template>

<script>

import Controller from './CrtCompaniesFound';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

import ModalTerm from '../../Company/Modal/Term/ModalTerm';
import ModalTermParts from '../../Company/Modal/Term/ModalTermParts';
import ModalTermServices from '../../Company/Modal/Term/ModalTermService';
import ModalTermCertifies from '../../Company/Modal/Term/ModalTermCertifie';

import ListOrdersParts from './Parts/ListOrdersParts';
import ListOrdersServices from './Services/ListOrdersServices';
import ListOrdersCertifie from './Certifies/ListOrdersCertifie';

import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
Vue.use(BootstrapVue)

export default {
    name: 'Dashboard',
    components: {
    Spinner,
    Toast,
    ListOrdersParts,
    ListOrdersServices,
    ListOrdersCertifie,
    ModalTerm,
    ModalTermParts,
    ModalTermServices,
    ModalTermCertifies
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            orders: [],
            checkTerm: null,
            dataCompany:{},
            data: {
            },
            user: {
                serviceTypes: []
            }
        }
    },
    methods: Controller.methods,
    created() {
    },
    mounted() {
        Controller.init(this);
    }
    }
    </script>

    <style>
    </style>
